import { render, staticRenderFns } from "./EditAboutModal.vue?vue&type=template&id=154c7884&"
import script from "./EditAboutModal.vue?vue&type=script&lang=js&"
export * from "./EditAboutModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EditAboutModal.vue"
export default component.exports